const Button = ({ className, text, type, onClick }) => {
  const btnType = ["default"].includes(type) ? type : "default";

  return (
    <button
      className={["Button", `Button_${btnType}`, className].join(" ")}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

Button.defaultProps = {
  type: "default",
};

export default Button;
